<script lang="ts">
import type { MicroCMSImage } from "microcms-js-sdk";
import ArrowForwardSvg from "./icons/arrow-forward-svg.svelte";

export let href: string;
export let name: string;
export let area: string;
export let images: MicroCMSImage[] = [];
/** サムネイル領域を常に表示する（画像がなければ枠のみ） */
export let showThumbnail = false;
</script>

<a
  {href}
  class="group flex h-full flex-col overflow-hidden border border-solid border-borderGray bg-white rounded-lg hover:border-white hover:outline hover:outline-2 hover:outline-action"
>
  {#if showThumbnail}
    <div class="aspect-[3/2] w-full shrink-0 overflow-hidden border-b border-solid border-borderGray bg-bgGray">
      {#if images.length > 0}
        <img
          src={images[0].url}
          alt={name}
          width={images[0].width}
          height={images[0].height}
          class="h-full w-full object-cover"
          loading="lazy"
        />
      {/if}
    </div>
  {/if}
  <div class="flex flex-1 flex-col p-4 sm:p-6">
    <span class="w-fit rounded-md border border-solid bg-white border-primary px-3 py-1 text-sm font-bold tracking-wide text-primary">
      {area}
    </span>
    <div class="mt-auto flex items-center justify-between gap-4 pt-2">
      <h2 class="mb-0 text-base font-bold tracking-wide group-hover:text-action">
        {name}
      </h2>
      <div class="shrink-0 [&_svg]:fill-action">
        <ArrowForwardSvg size={16} />
      </div>
    </div>
  </div>
</a>
